import { BREAKPOINT_DESKTOP, BREAKPOINT_TABLET } from '../constants/CommonConstants';

export const getCategoryComponent = (innerComp: string, item: string | undefined) => {
  const componentSpa = item?.split('/')[0];
  const leisureComponentPathMap: Record<string, string> = {
    DynamicPropertyCards: 'DynamicPropertyCards',
    PropertiesList: 'PropertiesList',
    CardCarouselResorts: 'CardCarouselResorts',
    TabComponentContainer: 'TabIconNavigation',
  };

  if (componentSpa === 'mi-aem-awp' && innerComp === 'CardCarouselContainer') {
    return import(`../../../mi-awp-components/src/organisms/CardCarouselContainer`).then(module => ({
      default: module[`${innerComp}`],
    }));
  }

  if (componentSpa === 'mi-aem-homepage-spa') {
    return import(`../../../mi-homepage-components/src/organisms/${innerComp}/index`).then(module => ({
      default: module[`${innerComp}`],
    }));
  }

  if (componentSpa === 'mi-aem-leisure-spa') {
    const leisureComponentPath = leisureComponentPathMap[innerComp] || innerComp;
    return import(`../../../mi-leisure-components/src/organisms/${leisureComponentPath}/index`).then(module => ({
      default: module[`${innerComp}`],
    }));
  }

  return import(`../../../mi-common-static-components/src/organisms/${innerComp}/index`).then(module => ({
    default: module[innerComp],
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const buildCategoryItemProps = (item: any, innerComp: string, props?: any) => {
  const componentSpa = item?.[':type']?.split('/')[0];

  if (componentSpa === 'mi-aem-awp' && innerComp === 'CardCarouselContainer') {
    return {
      model: { ...item },
      ...item,
      componentPath: props?.componentPath,
      ...(item?.[':items'] ? { cqItems: item[':items'] } : {}),
    };
  }
  return { model: { ...item }, ...item, componentPath: props?.componentPath };
};

export const useGetBreakpoint = (): string | undefined => {
  if (typeof window !== 'undefined' && window?.screen && window?.screen?.width) {
    return window.innerWidth > BREAKPOINT_DESKTOP
      ? 'desktop'
      : window.innerWidth > BREAKPOINT_TABLET
      ? 'tablet'
      : 'mobile';
  } else {
    return undefined;
  }
};
